var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline",style:(_vm.customVuexStyles)},[(_vm.title)?_c('h3',{staticClass:"headline__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.desc)?_c('p',{staticClass:"headline__desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }